import {registerTemplateGraphNode} from "#template/template-node/register"
import {curveGeometryAttributeLike, curveGeometryAttributeLikeMarker} from "#template/nodes/geometry-graph/attribute/attribute-node"
import type {CurveGeometryAttributeLikeNode} from "#template/nodes/geometry-graph/attribute/attribute-node"

import type {TemplateNodeDefinition} from "#template/template-node/types"
import {getTemplateNodeReturns} from "#template/template-node/validation"

import type {GetAttributeComponentParameters} from "#template/nodes/geometry-graph/attribute/get-attribute-component/geometry-get-attribute-component-node"
import {
    GeometryGetAttributeComponentNode,
    getAttributeComponentParametersSchema,
} from "#template/nodes/geometry-graph/attribute/get-attribute-component/geometry-get-attribute-component-node"

export type CurveGeometryGetAttributeComponentParameters = GetAttributeComponentParameters<CurveGeometryAttributeLikeNode>

const definition: TemplateNodeDefinition<CurveGeometryGetAttributeComponentParameters> = {
    nodeClass: "CurveGeometryGetAttributeComponent",
    validation: {
        parameters: getAttributeComponentParametersSchema(curveGeometryAttributeLike),
        returns: getTemplateNodeReturns(),
    },
}

@registerTemplateGraphNode
export class CurveGeometryGetAttributeComponent
    extends GeometryGetAttributeComponentNode<1, CurveGeometryAttributeLikeNode>
    implements CurveGeometryAttributeLikeNode
{
    get [curveGeometryAttributeLikeMarker]() {
        return true as const
    }

    public override get definition() {
        return definition
    }
}
